
import { useState } from 'react';

const Hero = () => {
  return (
    <section 
      className="relative min-h-screen flex items-center justify-center overflow-hidden"
      style={{
        backgroundImage: `url('https://static.readdy.ai/image/a613879414bb29b90c6692df9059d49e/c1c60d30424925e99c54603e92ef388e.jpeg')`,
        backgroundSize: 'cover',
        backgroundPosition: 'center',
        backgroundAttachment: 'fixed'
      }}
    >
      {/* Overlay para mejorar legibilidad */}
      <div className="absolute inset-0 bg-black/30"></div>
      
      {/* Contenido principal */}
      <div className="relative z-10 text-center text-white px-4 max-w-6xl mx-auto w-full">
        <h1 className="text-6xl md:text-8xl lg:text-9xl font-bold mb-6" style={{ fontFamily: 'Pacifico, serif' }}>
          Ecoffetours
        </h1>
        
        <p className="text-xl md:text-2xl lg:text-3xl mb-4 font-light tracking-wide">
          AGENCIA DE TURISMO
        </p>
        
        <div className="mb-8">
          <p className="text-2xl md:text-3xl lg:text-4xl font-semibold mb-2 text-yellow-400" style={{ fontFamily: 'Pacifico, serif' }}>
            Mongua, tierra del sol naciente
          </p>
        </div>
        
        {/* Características destacadas */}
        <div className="grid grid-cols-2 md:grid-cols-4 gap-6 mt-16">
          <div className="text-center">
            <div className="w-16 h-16 mx-auto mb-3 bg-white/20 rounded-full flex items-center justify-center">
              <i className="ri-footprint-line text-2xl"></i>
            </div>
            <p className="text-sm font-medium">Senderismo</p>
          </div>
          <div className="text-center">
            <div className="w-16 h-16 mx-auto mb-3 bg-white/20 rounded-full flex items-center justify-center">
              <i className="ri-camera-line text-2xl"></i>
            </div>
            <p className="text-sm font-medium">Avistamiento de Aves</p>
          </div>
          <div className="text-center">
            <div className="w-16 h-16 mx-auto mb-3 bg-white/20 rounded-full flex items-center justify-center">
              <i className="ri-tent-line text-2xl"></i>
            </div>
            <p className="text-sm font-medium">Camping</p>
          </div>
          <div className="text-center">
            <div className="w-16 h-16 mx-auto mb-3 bg-white/20 rounded-full flex items-center justify-center">
              <i className="ri-leaf-line text-2xl"></i>
            </div>
            <p className="text-sm font-medium">Ecoturismo</p>
          </div>
        </div>
      </div>
      
      {/* Indicador de scroll */}
      <div className="absolute bottom-8 left-1/2 transform -translate-x-1/2 text-white animate-bounce">
        <i className="ri-arrow-down-line text-2xl"></i>
      </div>
    </section>
  );
};

export default Hero;
